import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import Root from 'root'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import {
	ReactPlugin,
	withAITracking
} from '@microsoft/applicationinsights-react-js'
import { createBrowserHistory } from 'history'
import { ENV, environments, getEnvironment } from 'utils/environment'
import * as Sentry from '@sentry/browser'
import TagManager from 'react-gtm-module'
import * as serviceWorker from './serviceWorker'

// create a history object for App Insights routing telemetry
const browserHistory = createBrowserHistory({ basename: '' })

// React plugin instance for AI tracking
const reactPlugin = new ReactPlugin()

// only enable all tracking in prod
const isProd = getEnvironment() === environments.prod

let RootWithInsights = Root

if (isProd) {
	// --- Application Insights ---
	const appInsights = new ApplicationInsights({
		config: {
			instrumentationKey: ENV.INSTRUMENTATION_KEY,
			extensions: [reactPlugin],
			extensionConfig: {
				[reactPlugin.identifier]: { history: browserHistory }
			}
		}
	})
	appInsights.loadAppInsights()
	RootWithInsights = withAITracking(reactPlugin, Root)

	// --- Google Tag Manager ---
	TagManager.initialize({ gtmId: ENV.GTAG })

	// --- Sentry Error Tracking ---
	Sentry.init({ dsn: ENV.SENTRY_DSN })
}

ReactDOM.render(<RootWithInsights />, document.getElementById('root'))

// disable service worker by default; change to register() if you want PWA behavior
serviceWorker.unregister()
